import Terms from './components/terms';
import ShortSurveys from './components/playful/short-surveys';
import request from './request';
import { TRANSFORMATION_DATA_TYPE_JSON } from './constants';

/* eslint-disable */
// object holding data and functions regarding short surveys
Pollfish.shortSurveys = {};

Pollfish.shortSurveys.present = function() {
  const { questions } = Pollfish.helper.json;
  // get the index in array from where to start based on head id
  Pollfish.helper.shortHead = questions.indexOf(
    $.grep(questions, function(e) {
      return e.id === Pollfish.helper.json.head_id;
    })[0],
  );

  // make necessary mutations. Refactor in this branch didn't include making playful readable.
  // They will either be deprecated or updated in the future. Until then we do the minimum work
  // needed for these to work
  for (var i = questions.length - 1; i >= 0; i--) {
    const question = questions[i];
    question.answersById = {};
    for (var j = question.answers.length - 1; j >= 0; j--) {
      const answer = question.answers[j];
      question.answersById[answer.id] = answer;
    }
    Pollfish.helper.questions[question.id] = question;
  }

  const shortSurveys = new ShortSurveys(
    Pollfish.helper.json.questions,
  ).render();
  $('.main-content').html(shortSurveys);
  $('body').attr('data-page', 'playful');

  var fontSizeNoParticipate = parseInt($('#noParticipate').css('font-size'));
  while (
    $('#noParticipateContainer')[0].scrollHeight >
    $('#noParticipateContainer').height()
  ) {
    $('#noParticipate').css({ 'font-size': --fontSizeNoParticipate + 'px' });
  }

  // on tap/click close the panel and show indicator
  $('#noParticipateContainer').on('tap', function() {
    if (!$('#noParticipateContainer').hasClass('deactivate')) {
      Pollfish.mobile.interface.closeAndNoShow();
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/set/survey/reject',
        '{"s_id": "' + Pollfish.helper.json.s_id + '"}',
        false,
      );
    }
  });

  // on finger-down highlight
  $('#noParticipateContainer').on('vmousedown', function() {
    $(this).addClass('noParticipateContainerActive');
  });

  // on finger-up remove highlight
  $('#noParticipateContainer').on('vmouseup', function() {
    $(this).removeClass('noParticipateContainerActive');
  });

  // on scroll remove highlight
  $('#noParticipateContainer').on('scrollstart', function() {
    $(this).removeClass('noParticipateContainerActive');
  });

  // handle answers' ux and functionality
  Pollfish.shortSurveys.bindAnswerShort();

  new Terms({
    elem: '.js-terms',
    currentPage: 'terms',
    mainContent: $('.main-content'),
    moveBackBtn: $('.header__action-move-back-btn'),
  }).renderShort();
};

Pollfish.shortSurveys.results = function() {
  var isSurveyCompleted = true;
  for (var questionId in Pollfish.helper.questions) {
    if (!Pollfish.helper.questions[questionId].completed) {
      isSurveyCompleted = false;
    } else {
      $('#q-' + questionId).html(
        Pollfish.ui.templateResultChoiceShort(
          Pollfish.helper.questions[questionId],
        ),
      );

      Pollfish.shortSurveys.barAnimation(Pollfish.helper.questions[questionId]);

      Pollfish.shortSurveys.participate();
    }
  }

  if (isSurveyCompleted) {
    if (Pollfish.helper.isHtmlOnly) {
      return false;
    }

    Pollfish.ui.thankYou(0, {});
  }
};

// bind short answers with save and show results
Pollfish.shortSurveys.bindAnswerShort = function() {
  var answerShort = '.answerShort';

  $('#containerShort').on('tap', answerShort, function() {
    if (!Pollfish.helper.acceptedPlayful) {
      // send data to server
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/set/survey/accept',
        '{"s_id": "' + Pollfish.helper.json.s_id + '"}',
        false,
      );
      Pollfish.helper.acceptedPlayful = true;
    }
    var question =
      Pollfish.helper.questions[
        $(this)
          .closest('.questionShort')
          .attr('id')
          .split('-')[1]
      ];
    var answerId = $(this)
      .attr('id')
      .split('-')[1];

    // increase selected answer votes
    question.answersById[answerId].votes++;

    // calculate total votes
    var totalVotes = 0;
    for (var i = 0; i < question.answers.length; i++) {
      totalVotes += question.answers[i].votes;
    }

    // calculate percentage
    var maxPercentage = 0;
    var maxId;
    for (var j = 0; j < question.answers.length; j++) {
      question.answers[j].percentage = (
        (question.answers[j].votes / totalVotes) *
        100
      ).toFixed(2);

      if (
        parseFloat(question.answers[j].percentage) >= parseFloat(maxPercentage)
      ) {
        maxId = question.answers[j].id;
        maxPercentage = question.answers[j].percentage;
      }
    }

    question.answersById[maxId].isMax = 'green';

    // remove tag question id prefix
    var q_id = question.isTag ? question.id.substr(4) : question.id;

    var params =
      '{"s_id": "' +
      Pollfish.helper.json.s_id +
      '", "q_id": "' +
      q_id +
      '", "answer_ids": "' +
      answerId +
      '"}';
    const requestObject = {
      s_id: Pollfish.helper.json.s_id,
      answer_ids: answerId,
      q_id,
    };

    if (question.isTag) {
      // send the selected answer to the server
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/set/tag/question/answered',
        params,
        true,
      );
    } else {
      Pollfish.helper.savedAns.push(params);
      // send the selected answer to the server
      request({
        url: '/v2/device/save/answers',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        transformData: true,
        transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
        data: requestObject,
      });
    }

    // mark question as completed
    question.completed = true;

    var heightBefore = $('#q-' + question.id).height();
    $($(this).closest('.questionShort')).html(
      Pollfish.ui.templateResultChoiceShort(question),
    );
    var heightAfter = $('#q-' + question.id).height();

    if (heightBefore > heightAfter) {
      $('#q-' + question.id).css({ background: '#3a4046' });
      $('#q-' + question.id).height(heightBefore);
    }

    Pollfish.shortSurveys.barAnimation(question);

    Pollfish.shortSurveys.isSurveyCompleted(question);

    Pollfish.shortSurveys.participate();
  });

  // on finger-down highlight
  $(answerShort).on('vmousedown', function() {
    $(this).addClass('answerShortActive');
  });

  // on finger-up remove highlight
  $(answerShort).on('vmouseup', function() {
    $(this).removeClass('answerShortActive');
  });

  // on scroll remove highlight
  $(answerShort).on('scrollstart', function() {
    $(this).removeClass('answerShortActive');
  });

  var answerMultipleShort = '.answerMultipleShort';

  if ($(answerMultipleShort).length !== 0) {
    $('#containerShort').on('tap', answerMultipleShort, function() {
      $(this).toggleClass('answerMultipleShortActive');

      if ($(this).hasClass('answerMultipleShortActive')) {
        $(this)
          .find('.tick')
          .show();
      } else {
        $(this)
          .find('.tick')
          .hide();
      }
    });

    // on finger-down highlight
    $(answerMultipleShort).on('vmousedown', function() {
      $(this)
        .find('.tick')
        .show();
      $(this).addClass('answerMultipleShortActiveFake');
    });

    // on finger-up remove highlight
    $(answerMultipleShort).on('vmouseup', function() {
      $(this).removeClass('answerMultipleShortActiveFake');
    });

    // on scroll remove highlight
    $(answerMultipleShort).on('scrollstart', function() {
      $(this).removeClass('answerMultipleShortActiveFake');
      if (
        !$(this).hasClass('answerMultipleShortActiveFake') &&
        !$(this).hasClass('answerMultipleShortActive')
      ) {
        $(this)
          .find('.tick')
          .hide();
      }
    });

    var answerMultipleOkShort = '.answerMultipleOkShort';

    $('#containerShort').on('tap', answerMultipleOkShort, function() {
      if (!Pollfish.helper.acceptedPlayful) {
        // send data to server
        Pollfish.mobile.interface.sendToServer(
          '/v2/device/set/survey/accept',
          '{"s_id": "' + Pollfish.helper.json.s_id + '"}',
          false,
        );
        Pollfish.helper.acceptedPlayful = true;
      }

      $(this).addClass('answerMultipleOkShortActive');

      var question =
        Pollfish.helper.questions[
          $(this)
            .closest('.questionShort')
            .attr('id')
            .split('-')[1]
        ];

      if (
        $('#q-' + question.id).find('.answerMultipleShortActive').length === 0
      ) {
        return false;
      }

      var params =
        '{"s_id": "' +
        Pollfish.helper.json.s_id +
        '", "q_id": "' +
        question.id +
        '", "answer_ids": "';
      var answers_ids = '';

      for (
        var i = 0;
        i < $('#q-' + question.id).find('.answerMultipleShortActive').length;
        i++
      ) {
        var answerId = $(
          $('#q-' + question.id).find('.answerMultipleShortActive')[i],
        )
          .attr('id')
          .split('-')[1];
        answers_ids += answerId + ',';

        // increase selected answer votes
        question.answersById[answerId].votes++;
      }

      answers_ids = answers_ids.substr(0, answers_ids.length - 1);
      params += answers_ids + '"}';
      const requestObject = {
        s_id: Pollfish.helper.json.s_id,
        answer_ids: answers_ids,
        q_id: question.id,
      };

      if (question.isTag) {
        // send the selected answer to the server
        Pollfish.mobile.interface.sendToServer(
          '/v2/device/set/tag/question/answered',
          params,
          true,
        );
      } else {
        Pollfish.helper.savedAns.push(params);
        // send the selected answer to the server
        request({
          url: '/v2/device/save/answers',
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          transformData: true,
          transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
          data: requestObject,
        });
      }

      // calculate total votes
      var totalVotes = 0;
      for (var l = 0; l < question.answers.length; l++) {
        totalVotes += question.answers[l].votes;
      }

      // calculate percentage
      var maxPercentage = 0;
      var maxId;
      for (var j = 0; j < question.answers.length; j++) {
        question.answers[j].percentage = (
          (question.answers[j].votes / totalVotes) *
          100
        ).toFixed(2);

        if (
          parseFloat(question.answers[j].percentage) >=
          parseFloat(maxPercentage)
        ) {
          maxId = question.answers[j].id;
          maxPercentage = question.answers[j].percentage;
        }
      }

      question.answersById[maxId].isMax = 'green';

      // mark question as completed
      question.completed = true;

      var heightBefore = $('#q-' + question.id).height();
      $($(this).closest('.questionShort')).html(
        Pollfish.ui.templateResultChoiceShort(question),
      );
      var heightAfter = $('#q-' + question.id).height();

      if (heightBefore > heightAfter) {
        $('#q-' + question.id).css({ background: '#3a4046' });
        $('#q-' + question.id).height(heightBefore);
      }

      Pollfish.shortSurveys.barAnimation(question);
      Pollfish.shortSurveys.participate();

      Pollfish.shortSurveys.isSurveyCompleted(question);
    });

    // on finger-down highlight
    $(answerMultipleOkShort).on('vmousedown', function() {
      $(this).addClass('answerMultipleOkShortActive');
    });

    // on finger-up remove highlight
    $(answerMultipleOkShort).on('vmouseup', function() {
      $(this).removeClass('answerMultipleOkShortActive');
    });

    // on scroll remove highlight
    $(answerMultipleOkShort).on('scrollstart', function() {
      $(this).removeClass('answerMultipleOkShortActive');
    });
  }
};

Pollfish.shortSurveys.barAnimation = function(question) {
  for (var i = 0; i < question.answers.length; i++) {
    $('#resultShortAnsBar-' + question.answers[i].id).animate(
      { width: question.answers[i].percentage + '%' },
      'fast',
    );
  }
};

Pollfish.shortSurveys.participate = function() {
  $('#noParticipate').text('Thank you for joining!');
  $('#noParticipateContainer').addClass('deactivate');

  // send device data only the first time
  // check if hasaccepted exists
  // if(Pollfish.mobile.interface.deviceInfo.hasaccepted !== "true"){
  // Pollfish.mobile.interface.sentDataOfUserConsentToServer('/v2/device/info');
  // Pollfish.mobile.interface.deviceInfo.hasaccepted = "true";
  // }
};

Pollfish.shortSurveys.isSurveyCompleted = function(question) {
  var isSurveyCompleted = false;
  for (
    var i = Pollfish.helper.shortHead;
    i < Pollfish.helper.json.questions.length;
    i++
  ) {
    if (!Pollfish.helper.json.questions[i].completed) {
      isSurveyCompleted = false;
      break;
    } else {
      isSurveyCompleted = true;
    }
  }

  // if all answers are completed then complete the surveys
  if (isSurveyCompleted) {
    Pollfish.mobile.interface.setSurveyCompleted();

    var isValidParams = {
      s_id: Pollfish.helper.json.s_id,
      sanity_check: true,
      repeat_check: true,
    };

    isValidParams.string =
      '{"s_id": "' +
      Pollfish.helper.json.s_id +
      '", "sanity_check": "' +
      isValidParams.sanity_check +
      '", "repeat_check": "' +
      isValidParams.repeat_check +
      '", "answers": [' +
      Pollfish.helper.savedAns +
      ']}';

    Pollfish.mobile.interface.sendToServer(
      '/v2/device/set/survey/completed',
      isValidParams.string,
      true,
    );

    if (Pollfish.helper.isHtmlOnly) {
      return false;
    }

    Pollfish.ui.thankYouBasic();
  }
};

export default Pollfish.shortSurveys;
/* eslint-enable */
